import { createTheme } from '@mui/material/styles'

export const materialTheme = createTheme({
	palette: {
		primary: {
			main: '#f50537',
		},
	},
})
